import api from "./API";
import { url, ApiEndpointConstants } from "../constants/ApiEndpointConstants";
import getAd from "../utils/GetAd";
import getWWWUrl from "../utils/getWWWUrl";

export const countPixelEvent = (eventname, eventid) => {
  return api.post(`https://www.adminv.online/api/Events/addevent`, {
    url: getWWWUrl(url),
    ad: getAd(),
    eventname,
    eventid,
  });
};
